<template>
  <div class="custom-order">
    <Breadcrumb />
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="80px">
        <el-row v-if="user.userType != '00'" :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpandShop"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpandShop || index < 10) &&
                          item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpandShop = !isExpandShop"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #409eff;
                    float: left;
                  "
                >
                  {{ isExpandShop ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="产品名称：" class="item">
                <el-input
                  clearable
                  v-model="form.productName"
                  placeholder=""
                  size="small"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="sellerSku：" class="item">
                <el-input
                  clearable
                  v-model="form.sellerSku"
                  placeholder=""
                  size="small"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="操作人：" prop="operNo">
                <el-input
                  clearable
                  v-model="form.operNo"
                  placeholder=""
                  size="small"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col v-if="false" :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="发布状态：" class="item">
                <el-input
                  clearable
                  v-model="form.sellerSku"
                  placeholder=""
                  size="small"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="创建时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.createTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="item right">
              <el-button type="primary" size="small" @click="getData(1)"
                >搜索</el-button
              >
              <el-button type="default" size="small" @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top table-menu">
           <div class="left">
    
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-row style="display: flex; flex-wrap: wrap; background-color: white">
        <el-col
          :span="12"
          style="
            display: flex;
            padding-left: 20px;
            color: #333333;
            font-size: 14px;
            align-items: center;
          "
        >
          <div v-if="rowSelectNum > 0">已选中{{ rowSelectNum }}条数据</div>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column label="产品" width="230px" prop="designId">
          <template slot-scope="scope">
            <div style="overflow:hidden;">
              <div style="float:left;text-align:center;padding-left:47px;">
                <el-tooltip placement="bottom" effect="light">
                  <div slot="content">
                    <img
                      :src="
                        scope.row.picList && scope.row.picList.length > 0
                          ? scope.row.picList[0].lazadaPicUrl
                          : ''
                      "
                      style="width:300px;height:300px;margin: 0 0 0 5px;"
                    />
                  </div>
                  <img
                    style="width:100px;height:100px;margin: 0 0 0 5px;"
                    :src="
                      scope.row.picList && scope.row.picList.length > 0
                        ? scope.row.picList[0].lazadaPicUrl
                        : ''
                    "
                  />
                </el-tooltip>
              </div>
              <div style="float:left;">
                <a target="_blank" :href="scope.row.productUrl">{{
                  scope.row.productName
                }}</a
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="所属店铺"
          width="169px"
          align="center"
          prop="shopName"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.shopName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="sellerSku"
          header-align="center"
          align="left"
          prop="itemSku"
          width="200px"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.sellerSku"
              class="text-ellipsis"
              style="width:200px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.sellerSku }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.sellerSku"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.sellerSku }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#409eff;cursor:pointer;"
                >{{ scope.row.expand ? "收起" : "展开" }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="颜色"
          header-align="center"
          align="left"
          prop="color"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.color"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.color }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.color"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.color }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#409eff;cursor:pointer;"
                >{{ scope.row.expand ? "收起" : "展开" }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="尺码"
          header-align="center"
          align="left"
          prop="size"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.size"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.size }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.size"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.size }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#409eff;cursor:pointer;"
                >{{ scope.row.expand ? "收起" : "展开" }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="价格"
          header-align="center"
          align="left"
          prop="price"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.price"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.price }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.price"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.price }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#409eff;cursor:pointer;"
                >{{ scope.row.expand ? "收起" : "展开" }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="库存" width="175px" prop="quantity">
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.quantity"
              class="text-ellipsis"
              style="width:175px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.quantity }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.quantity"
              class="text-ellipsis"
              style="width:175px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.quantity }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#409eff;cursor:pointer;"
                >{{ scope.row.expand ? "收起" : "展开" }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="nickName" width="120">
          <template slot-scope="scope">
            {{ scope.row.nickName ? scope.row.nickName : scope.row.operNo }}
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="remitTime" width="170">
          <template slot-scope="scope">
            <div>创建时间：<br />{{ scope.row.createTime }}</div>
            <div>更新时间：<br />{{ scope.row.updateTime }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="activeName == 'on' || activeName == 'off'"
          width="69"
          label="操作"
          prop="size"
        >
          <template slot-scope="scope">
            <div class="operate">
              <span class="link" @click="handleEdit(scope.row)">
                编辑
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>

    <ExpreDetail
      @onClose="handleCloseExpre"
      :detail="expreDetail"
      :visible="expreVisible"
    ></ExpreDetail>

    <!-- 编辑订单弹窗 -->
    <EditOrder
      v-if="currentOrder && currentOrder.order"
      :canEdit="orderCanEdit"
      :appId="currentAppId"
      :visible="showEdit"
      :orderDetail="currentOrder"
      @onClose="hideEdit"
      @onUpdate="onUpdateFinish"
    />

    <!-- 同步订单弹窗 -->
    <SyncOrder
      :platNo="`03`"
      :visible="showSyncOrder"
      @onClose="hideSyncOrder"
      @update="getData"
    />

    <!-- 汇率设置弹窗 -->
    <ExchangeDialog
      :visible="showExchange"
      @onClose="hideExchange"
      @onOk="okEditExchange"
    />

    <!-- 取消订单设置弹窗 -->
    <CancelDialog
      :orderData="currentOrder"
      :visible="showCancel"
      @onClose="hideCancel"
      @onOk="okEditCancel"
    />

    <!-- 手续费设置弹窗 -->
    <ServiceDialog
      :visible="showService"
      @onClose="hideService"
      @onOk="okEditService"
    />
    <!-- 发货时间设置弹窗 -->
    <sendDialog
      :orderData="currentOrder"
      :visible="showSendTime"
      @onClose="hideSendTime"
      @onOk="okEditSendTime"
    />

    <!-- 备注弹窗 -->
    <RemarkDialog :visible="showRemark" @onClose="hideRemark" />

    <!-- 复制弹窗 -->
    <CopyOrder
      v-if="currentOrder.order"
      :visible="showCopy"
      @onClose="hideCopy"
      :orderData="currentOrder"
      @onOk="okCopyOrder"
    />

    <!-- 销售设置弹窗 -->
    <EditSale
      :visible="showEditSale"
      @onClose="hideEditSale"
      :orderData="currentOrder"
      @onOk="okEditSale"
    />

    <!-- 订单审核弹窗 -->
    <AuditOrder
      :visible="showAuditOrder"
      @onClose="hideAuditOrder"
      :orderData="currentOrder"
      @onOk="okAuditOrder"
    />

    <!-- 订单审核弹窗 -->
    <AcceptOrder
      :visible="showAcceptOrder"
      @onClose="hideAcceptOrder"
      :orderData="currentOrder"
      @onOk="okAcceptOrder"
    />

    <!-- 选择快递弹窗 -->
    <SelectShip
      :orderData="currentOrder"
      :visible="showShip"
      @onClose="hideShip"
    />

    <!-- 发货弹窗 -->
    <SendOrderFlb
      :orderData="currentOrder"
      :visible="showSendOrder"
      @onClose="hideSendOrder"
    />

    <!-- 同步订单弹窗 -->
    <SyncOrder
      :isSyncProduct="true"
      :platNo="`03`"
      :visible="showSyncOrder"
      @onClose="hideSyncOrder"
      @update="getData"
    />

    <el-dialog
      title="产品列表"
      :visible.sync="detailVisible"
      width="60%"
      :before-close="handleCloseDetail"
    >
      <el-table :data="productList" class="exchange-table">
        <el-table-column prop="shippingMethodName" label="主题名称">
          <template slot-scope="scope">
            <a style="cursor: pointer" @click="handleOpenProduct(scope.row)">{{
              scope.row.proName
            }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="color" label="颜色"> </el-table-column>
        <el-table-column prop="size" label="尺码"> </el-table-column>
        <el-table-column prop="quantity" label="数量"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleCloseDetail"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="`上传面单`"
      :visible.sync="showUploadLabel"
      width="540px"
      class="remarkDialog"
    >
      <el-form
        :rules="rules"
        :model="importForm"
        ref="importForm"
        label-width="120px"
      >
        <el-form-item prop="file" label="选择文件：">
          <input
            type="file"
            name="file"
            class="webuploader"
            accept=""
            @change="uploadFn"
            ref="inputer"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUploadLabel = false" size="small"
          >返回</el-button
        >
        <el-button type="primary" @click="handleUploadLabel" size="small">
          保存
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="previewImagesVisible"
      width="800px"
    >
      <div class="preview-area">
        <div class="carousel">
          <el-carousel
            ref="carouselPreview"
            style="height: 500px; overflow: hidden"
            :autoplay="false"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              style="height: 500px;"
              v-for="(productImage, index) in productImageList"
              :key="index"
            >
              <img :src="productImage" />
            </el-carousel-item>
          </el-carousel>
          <div v-if="false" class="color-picker">
            <ul class="color-picker-list">
              <li
                @click="handlePickColor(record)"
                v-for="record of colorList"
                :key="record"
                :class="{ cur: currentColor === record }"
              >
                <a :style="{ backgroundColor: dictMap['color'][record] }"></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="preview-list">
          <div
            v-for="(productImage, index) in productImageList"
            :key="index"
            class="preview-list-item"
            :class="{ 'is-active': activeCarousel === index }"
            @click="handleClickPreviewImage(index)"
          >
            <img :src="productImage" />
            <div class="preview-text">效果图{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="` `"
      :close-on-click-modal="false"
      :visible.sync="showConfirmDialog"
      width="540px"
      class="remarkDialog"
    >
      <div>建议编辑前先同步产品，确保数据和卖家中心保持一致</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfirmDialog = false" size="small"
          >返回</el-button
        >
        <el-button type="primary" @click="handleSyncAndEdit" size="small">
          同步&编辑
        </el-button>
        <el-button type="primary" @click="handleEditOrder" size="small">
          跳过&编辑
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import LoanTip from "./components/LoanTip"
import EditOrder from "./components/EditOrder"
import SyncOrder from "./components/SyncOrder"
import ExchangeDialog from "./components/ExchangeDialog"
import ServiceDialog from "./components/ServiceDialog"
import sendDialog from "./components/SetSendTime"
import RemarkDialog from "./components/RemarkDialog"
import EditSale from "./components/EditSale"
import CopyOrder from "./components/CopyOrder"
import AuditOrder from "./components/AuditOrder"
import AcceptOrder from "./components/AcceptOrder"
import SendOrderFlb from "./components/SendOrderFlb"
import CancelDialog from "./components/CancelOrder"
import { selectExpreList, getExpreProcess } from "@/api/order/all"
import { mapGetters } from "vuex"
import dayjs from "dayjs"
import {
  orderList,
  getOrderDetail,
  cancelOrder,
  recoveryOrder,
  orderToCopy,
  createShip,
  exportExcel,
  uploadTb,
  getDesignInfo,
} from "@/api/order/all"

import {
  getProductList,
  syncByShop,
  productOn,
  productOff,
  syncById,
} from "@/api/order/lazada"

import { getShipMethod } from "@/api/product/shipMethod"

import { getShopList } from "@/api/system/shopManage"
import noImage from "@/assets/images/no_image.png"
import SelectShip from "./components/SelectShip"
import qs from "qs"
import { downLoadExcel } from "@/utils/zipdownload"
import ExpreDetail from "./components/ExpreDetail"
import { listSubAccount } from "@/api/system/user"
import { listUser } from "@/api/business/merchantManage"

export default {
  name: "draftProduct",
  components: {
    Breadcrumb,
    SyncOrder,
    LoanTip,
    ExchangeDialog,
    ServiceDialog,
    sendDialog,
    EditOrder,
    RemarkDialog,
    CopyOrder,
    EditSale,
    AuditOrder,
    SelectShip,
    SendOrderFlb,
    ExpreDetail,
    CancelDialog,
    AcceptOrder,
  },
  data() {
    return {
      shopList: [],
      shopListClone: [],
      noImage: noImage,
      form: {
        shopId: [],
        productName: "",
        sellerSku: "",
        operNo: "",
        createTime: [],
        pageNum: 1,
        pageSize: 30,
        status: "01",
      },
      rules: {
        file: [{ required: true, message: "请选择文件", trigger: "change" }],
      },
      previewImagesVisible: false,
      productImageList: [],
      importForm: {
        appId: "",
        file: null,
      },
      activeCarousel: 0,
      showUploadLabel: false,
      cancelOrderVisible: false, //取消订单弹框
      modalTitle: "",
      modalText: "",
      statusText: "",
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      multipleSelection: [], // 选中列表数据
      showSyncOrder: false,
      showService: false,
      showExchange: false,
      showCancel: false,
      showEdit: false,
      showRemark: false,
      showShip: false,
      showCopy: false,
      showSendOrder: false,
      showConfirmDialog: false,
      showEditSale: false,
      showAuditOrder: false,
      showAcceptOrder: false,
      currentOrder: {},
      currentAppId: "",
      orderCanEdit: true,
      roles: [],
      shipList: [],
      isCheckShop: true,
      isCheckStatus: true,
      scrollMenu: null,
      objectHeight: null,
      expreList: [],
      expreDetail: {},
      expreVisible: false,
      isExpand: false,
      shopName: "",
      isExpandUser: false,
      nickName: "",
      isCheckUser: true,
      userList: [],
      activeName: "on",
      accountList: [],
      detailVisible: false,
      showSendTime: false,
      productList: [],
      dialogTitle: "效果图",
      isExpandShop: false,
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
    rowSelectNum() {
      return this.multipleSelection.length
    },
    showPayButton() {
      let permission = JSON.stringify(this.$store.state.permission)
      return permission.indexOf("GetPay") !== -1
    },
    orderWidth() {
      let width = document.body.clientWidth
      let orderWidth = "476"
      if (width > 1500) {
        orderWidth = "476"
      } else {
        orderWidth = "339"
      }
      return orderWidth
    },
    tdWidth() {
      let width = document.body.clientWidth
      let orderWidth = "200"
      if (width > 1400) {
        orderWidth = "189"
      } else {
        orderWidth = "129"
      }
      return orderWidth
    },
  },
  mounted() {
    // let curDate = new Date()
    // let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    // this.form.createTime = [
    //   this.parseTime(preDate, "{y}-{m}-{d}"),
    //   this.parseTime(curDate, "{y}-{m}-{d}"),
    // ]
    let appNo = this.$route.query.appNo
    if (appNo) {
      this.form.appNo = appNo
      this.form.createTime = []
    }
    let status = this.$route.query.status
    if (status) {
      this.activeName = status
    }

    this.getShops()
    this.getData()
    this.getShip()
    this.getUserList()
    this.getAccountList()

    this.roles = this.user.roles
    // this.dictData["order_status"].map((record) => {
    //   this.form.orderStatus.push(record.value)
    // })
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    handleShowMaps(row) {
      this.productImageList = []
      for (let record of row.maps) {
        this.productImageList.push(record.picUrl)
      }
      this.dialogTitle = "图片预览"
      this.previewImagesVisible = true
    },
    async handleShowDesignMaps(row) {
      this.productImageList = []
      let result = await getDesignInfo(row.designId)
      for (let record of result.data.skuList) {
        this.productImageList.push(record.mainPic.picUrl)
      }
      this.dialogTitle = "效果图预览"
      this.previewImagesVisible = true
    },
    async getAccountList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.accountList = result.rows
    },
    handleClickTab() {},
    handleCloseExpre() {
      this.expreVisible = false
    },

    getShops() {
      getShopList({ platNo: "03", authStatus: "02" }).then((res) => {
        this.shopList = res.rows
        this.shopListClone = this._.clone(res.rows)
        this.$nextTick(() => {
          this.scrollMenu = document.querySelector(".table-menu")
          this.objectHeight = this.scrollMenu.offsetTop
          window.addEventListener(
            "scroll",
            this.throttle(this.handleScroll, 100)
          )
        })
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    async productOff(row) {
      try {
        this.$confirm("确定下架吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.startLoading()
            await productOff({ pIds: row.pId })
            this.$message.success("下架成功！")
            this.getData()
          })
          .catch(() => {})
          .finally(() => {
            this.endLoading()
          })
      } catch (error) {}
    },
    async productOn(row) {
      try {
        this.$confirm("确定上架吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.startLoading()
            await productOn({ pIds: row.pId })
            this.$message.success("上架成功！")
            this.getData()
          })
          .catch(() => {})
          .finally(() => {
            this.endLoading()
          })
      } catch (error) {}
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    handleChangeStatus() {
      this.form.orderStatus = []
      if (this.isCheckStatus) {
        this.dictData["order_status"].map((record) => {
          this.form.orderStatus.push(record.value)
        })
      }
    },
    getShip() {
      getShipMethod().then((res) => {
        this.shipList = res.rows
      })
    },
    getUserList() {
      listSubAccount({}).then((res) => {
        res.rows.unshift({
          userName: this.user.name,
          nickName: this.user.nickName ? this.user.nickName : this.user.name,
        })
        this.userList = res.rows
      })
    },
    handleChangeUser() {
      this.form.operNos = []
      let shopList = this._.clone(this.shopListClone)
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNos.push(record.userName)
        })
        this.shopList = shopList
      } else {
        this.shopList = shopList.filter((shop) => {
          for (let record of this.form.operNos) {
            if (record == shop.operNo) {
              return true
            }
          }
          return false
        })
      }
      this.form.shopId = []
    },

    getProducingDay(date) {
      return (
        Math.floor(((new Date() - new Date(date)) / 1000 / 60 / 60 / 24) * 10) /
        10
      )
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    getShopList() {
      getShopList().then((res) => {
        this.shopList = res.rows
        let options = [
          {
            value: "amazon",
            label: "亚马逊店铺",
            children: [],
          },
          {
            value: "lazada",
            label: "lazada店铺",
            children: [],
          },
          {
            value: "other",
            label: "其他店铺",
            children: [],
          },
        ]
        res.rows.map((record) => {
          if (record.platNo == "04") {
            options[0].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else if (record.platNo == "03") {
            options[1].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else {
            options[2].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          }
        })

        if (this.importType == "amazon") {
          options.splice(1, 1)
        } else if (this.importType == "lazada") {
          options.splice(0, 1)
        }
        this.options = options
      })
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNos.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.form.operNos.includes(record.userName)) {
            for (let item of record.shops) {
              if (item.shopId == shop.shopId) {
                return true
              }
            }
          }
        }
        return false
      })

      this.form.shopId = []
      if (this.form.operNos.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
    },
    // 搜索
    getData() {
      let params = Object.assign({}, this.form)

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD")
      }

      params.shopIds = params.shopId.join(",")

      delete params["createTime"]
      delete params["lineTime"]
      delete params["sendTime"]
      delete params["shopId"]

      // if (this.activeName == "on") {
      //   params.status = "active"
      //   params.quantity = undefined
      // } else if (this.activeName == "clear") {
      //   params.status = "0"
      //   params.quantity = 0
      // } else if (this.activeName == "off") {
      //   params.status = "inactive"
      //   params.quantity = undefined
      // }

      this.startLoading()
      getProductList(params)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("获取订单列表失败")
          } else {
            this.total = res.total
            for (let record of res.rows) {
              record.expand = false
            }
            this.tableData = res.rows
          }
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleSelectShip(row) {
      this.currentOrder = row
      this.showShip = true
    },
    // 重置
    reset() {
      this.form = {
        shopId: [],
        productName: "",
        sellerSku: "",
        operNo: "",
        createTime: [],
        pageNum: 1,
        pageSize: 30,
        status: "01",
      }
    },
    copyText(text) {
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制成功")
      document.body.removeChild(target)
    },
    // 列表选择
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    GetOrderStatus(orderStatus) {
      if (orderStatus == "排单中") {
        return "待接单"
      }
      return orderStatus
    },
    syncOrder() {
      this.showSyncOrder = true
    },
    hideSyncOrder() {
      this.showSyncOrder = false
    },
    exchange() {
      this.showExchange = true
    },
    hideExchange() {
      this.showExchange = false
    },
    hideCancel() {
      this.showCancel = false
    },
    okEditExchange() {
      this.getData()
      this.showExchange = false
    },
    okEditCancel() {
      this.getData()
      this.showCancel = false
    },
    service() {
      this.showService = true
    },
    hideService() {
      this.showService = false
    },
    showAudit(data) {
      this.currentOrder = data
      this.showAuditOrder = true
    },
    showAccept(data) {
      this.currentOrder = data
      this.showAcceptOrder = true
    },
    handleShowSendOrder(data) {
      this.currentOrder = data
      this.showSendOrder = true
    },
    hideAuditOrder() {
      this.showAuditOrder = false
    },
    hideAcceptOrder() {
      this.showAcceptOrder = false
    },
    okEditService() {
      this.getData()
      this.showService = false
    },
    hideSendTime() {
      this.showSendTime = false
    },
    okEditSendTime() {
      this.getData()
      this.showSendTime = false
    },
    handleShowSendTime(data) {
      this.currentOrder = data
      this.showSendTime = true
      let a = 1
    },
    showOrderDetail(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
        this.orderCanEdit = false
      })
    },
    handleCommand(command) {
      if (command == "exchange") {
        this.showExchange = true
      } else if (command == "service") {
        this.showService = true
      }
    },
    // 编辑订单
    edit(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
        this.orderCanEdit = true
      })
    },
    hideEdit() {
      this.getData()
      this.showEdit = false
    },
    onUpdateFinish(appId) {
      if (appId) {
        getOrderDetail(appId).then((res) => {
          this.currentOrder = res.data
        })
      }
    },
    remark() {
      this.showRemark = true
    },
    hideRemark() {
      this.showRemark = false
    },
    hideShip() {
      this.showShip = false
      this.getData()
    },
    goReview() {
      const ids = []
      const orderStatusArray = []
      let shipFlag = true

      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
        orderStatusArray.push(el.orderStatus)
        if (!(el.expre && el.expre.shippingMethod)) {
          shipFlag = false
        }
      })

      if (orderStatusArray.length == 0) {
        this.$message.error("请选择订单")
        return false
      }

      for (let record of orderStatusArray) {
        if (record != "02") {
          this.$message.info("只有已付款的订单才能审核")
          return false
        }
      }
      this.currentOrder = {
        appNo: ids.join(","),
      }
      this.showAuditOrder = true
    },
    hideSendOrder() {
      this.showSendOrder = false
      this.getData()
    },
    handleClickPreviewImage(index) {
      this.$refs["carouselPreview"].setActiveItem(index)
      this.activeCarousel = index
    },
    // 复制订单
    copy(data) {
      orderToCopy(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showCopy = true
      })
    },
    hideCopy() {
      this.showCopy = false
    },
    showSale(data) {
      this.currentOrder = data
      this.showEditSale = true
    },
    hideEditSale() {
      this.showEditSale = false
    },
    okEditSale() {
      this.getData()
      this.showEditSale = false
    },
    okCopyOrder() {
      this.getData()
      this.showCopy = false
    },
    handleEditOrder() {
      this.$router.push({
        name: "EditProduct",
        params: { products: this.multipleSelection },
      })
    },
    handleEdit(row) {
      this.$router.push({
        path: "/carry/lazada/createLazada",
        query: { pId: row.pId },
      })
    },
    async handleSyncAndEdit() {
      let pIds = []
      for (let record of this.multipleSelection) {
        pIds.push(record.pId)
      }
      try {
        this.startLoading()
        let result = await syncById({ pIds: pIds.join(",") })
        this.endLoading()

        this.$router.push({
          name: "EditProduct",
          params: { products: this.multipleSelection },
        })
      } catch (error) {}
    },
    handleShowConfirmDialog() {
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择产品")
        return
      }
      this.showConfirmDialog = true
    },
    okAuditOrder() {
      this.getData()
      this.showAuditOrder = false
    },
    okAcceptOrder() {
      this.getData()
      this.showAcceptOrder = false
    },
    exportOrder() {
      let params = Object.assign({}, this.form)
      params.orderStatus = params.orderStatus.join(",")
      let ids = []
      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
      })
      if (ids.length > 0) {
        params.appNos = ids.join(",")
      }

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD")
      }

      if (this.form.lineTime && this.form.lineTime.length > 0) {
        params["lineTimeBegin"] = dayjs(this.form.lineTime[0]).format(
          "YYYY-MM-DD"
        )
        params["lineTimeEnd"] = dayjs(this.form.lineTime[1]).format(
          "YYYY-MM-DD"
        )
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        )
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        )
      }

      delete params["createTime"]
      delete params["lineTime"]
      delete params["sendTime"]
      delete params["pageNum"]
      delete params["pageSize"]
      downLoadExcel(
        `/server/order/export?${qs.stringify(params)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    // 取消订单
    cancelOrderFn(data) {
      this.$confirm("请确认是否取消订单？", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        cancelOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("取消失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "取消成功!",
            })
          }
        })
      })
    },
    async handleQuickOrder(row) {
      try {
        this.$confirm("请确认是否加急订单？", "加急订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.startLoading()
          let result = await createShip({ appId: row.appId })
          this.$message({
            type: "success",
            message: result.msg,
          })
          this.getData()
          this.endLoading()
        })
      } catch (error) {
        this.endLoading()
      }
    },
    async handleRefund(row) {
      try {
        this.$confirm("请确认是否取消订单？", "取消订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.currentOrder = row
          this.showCancel = true
        })
      } catch (error) {
        this.endLoading()
      }
    },
    // 恢复订单
    renewOrder(data) {
      this.$confirm("请确认是否恢复订单？", "恢复订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        recoveryOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("恢复失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "恢复成功!",
            })
          }
        })
      })
    },
    handleOpenDetail(row) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: row.pId, designId: row.designId },
      })
      window.open(routeUrl.href, "_blank")
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        if (row.isNew && row.count != 0) {
          return {
            rowspan: row.count,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    batchDownload() {
      //判断是否有支付权限
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单")
        return
      }

      const ids = []
      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
      })
      let routeUrl = this.$router.resolve({
        path: "/prod-api/server/order/downloadImage",
        query: { appNos: ids.join(",") },
      })
      window.open(routeUrl.href, "_blank")
    },
    getHourHint(s1) {
      if (s1) {
        var reDate = /\d{4}-\d{1,2}-\d{1,2} /
        s1 = new Date(
          (reDate.test(s1) ? s1 : "2018-1-1 " + s1).replace(/-/g, "/")
        )
        let s2 = new Date()
        var ms = Math.round((s1.getTime() - s2.getTime()) / 1000 / 60 / 60)
        if (ms >= 0 && ms <= 12) {
          return "将在" + ms + "小时后过期"
        } else {
          return "已过期" + ms + "小时"
        }
      } else {
        return ""
      }
    },
    goRelate(data) {
      this.$router.push({
        path: "/order/order_aid/toMatchOrder",
        query: {
          appNo: data.appNo,
        },
      })
    },
    handleShowUploadLabel(row) {
      this.importForm.appId = row.appId
      this.$refs.inputer ? (this.$refs.inputer.value = "") : ""
      this.showUploadLabel = true
    },
    uploadFn() {
      let inputDOM = this.$refs.inputer
      let file = inputDOM.files

      this.importForm.file = file
    },
    handleUploadLabel() {
      this.$refs["importForm"].validate((valid) => {
        if (valid) {
          this.startLoading()
          let formData = new FormData()

          formData.append("file", this.importForm.file[0])
          formData.append("appId", this.importForm.appId)

          uploadTb(formData)
            .then((res) => {
              if (res.code !== 200) {
                this.$message.error("上传失败")
              } else {
                this.$message.success("上传成功")
                this.showModal = false
                // this.successOrder = res.rows
                this.showUploadLabel = false
                this.getData()
              }
              this.endLoading()
            })
            .catch(() => {
              this.endLoading()
            })
        }
      })
    },
    handleShowDetail(record) {
      this.productList = record.shipList
      this.detailVisible = true
    },
    handleCloseDetail() {
      this.detailVisible = false
    },
    handleOpenProduct(row) {
      let routeUrl = ""
      if (row.productType == "01") {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { designId: row.designId },
        })
      } else {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { pId: row.pId },
        })
      }

      window.open(routeUrl.href, "_blank")
    },
    caculateProduct(data) {
      let count = 0
      for (let record of data) {
        count += Number(record.num)
      }
      return count
    },
    handleExpand(row) {
      row.expand = !row.expand
      row.skuList = this._.clone(row.skuList)
    },
    handleCheckAll() {
      this.form.shopId = []
      for (let record of this.shopList) {
        this.form.shopId.push(record.shopId)
      }
    },
    throttle(fn, wait) {
      var pre = Date.now()
      return function() {
        var context = this
        var args = arguments
        var now = Date.now()
        if (now - pre >= wait) {
          fn.apply(context, args)
          pre = Date.now()
        }
      }
    },
    handleScroll() {
      var menu = this.scrollMenu
      //获取页面的滚动距离
      var scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop
      //滚动到一定位置 div固定到顶部 js实现吸顶
      if (this.objectHeight < scrollHeight) {
        menu.style.position = "fixed"
        menu.style.top = 0
        menu.style.width = "calc(100% - 290px)"
        menu.style.padding = "8px 0"
      } else {
        menu.style.position = "relative"
        menu.style.width = "100%"
        menu.style.padding = "0"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
  min-height: 42px;
}

.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  width: 111px;
  height: 111px;
  margin-bottom: 10px;
  position: relative;
}

.table-info .left .mini-img {
  width: 109px;
  height: 109px;
  border: 1px solid #dddddd;
}

.table-info .right {
  font-size: 12px;
  width: 200px;
  padding: 0 0 4px 0;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.operate .link {
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}

.custom-order ::v-deep .el-select {
  width: 100%;
}

.custom-order ::v-deep .el-date-editor {
  width: 100%;
}
.preview-area {
  overflow: hidden;
  .carousel {
    width: 600px;
    float: left;
    .el-carousel__item {
      text-align: center;
    }
    ::v-deep .el-carousel__container {
      height: 500px;
    }
    ::v-deep .el-carousel__indicators {
      display: none;
    }
    img {
      width: 500px;
      height: 500px;
    }
  }
  .preview-list {
    width: 130px;
    float: left;
    height: 500px;
    margin: 0 0 0 16px;
    overflow-y: auto;
    .preview-list-item {
      border: 1px solid #e5e5e5;
      margin: 0 8px 15px 0;
      box-sizing: border-box;
      width: 111px;
      height: 111px;
      position: relative;
      cursor: pointer;
      .preview-text {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        padding: 0.05rem 0;
        font-size: 0.14rem;
        z-index: 10;
        font-size: 14px;
      }
      &:hover .preview-text {
        display: block;
      }
      &.is-active .preview-text {
        display: block;
        background: #1890ff;
      }
    }

    img {
      width: 109px;
      height: 109px;
    }
    .is-active {
      border: 1px solid #409eff;
    }
  }
  .color-picker {
    overflow: hidden;
    margin: 16px 8px 0 0;
    ul {
      overflow: hidden;
      padding: 0px 0 0 266px;
    }
  }

  .color-picker-list li,
  .color-picker-list-hover li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }
  .color-picker-list li.cur {
    border: #409eff solid 2px;
  }
  .color-picker-list li a,
  .color-picker-list-hover li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.product-type {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.product-tag {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: #ff9000;
  background-color: #ff9000;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}
.custom-order ::v-deep .el-tabs__item.is-active {
  background: #ffffff;
}
</style>
